// ! Warning: The DEBUG changes may cause issues with the production server.
const isDebugMode = import.meta.env.DEV;
export const DEBUG = isDebugMode;

const host = `${location.protocol}//${location.hostname}`;
let URLS = {
  FRONT: `${host}:9070`,
  BACK_DSH: `${location.origin}/api/dsh`,
  BACK_ENV: `${host}:7211/api/env`,
  WS: `ws://${location.hostname}:7212`,
  DSH_WS: `ws://${location.hostname}:7270`,
  MQTT_INTERNAL: 'wss://grobogan.beomhots.com/mqtt',
  MQTT_DSH: 'wss://grobogan.beomhots.com/mqtt-dsh',
  STREAM_PROXY: `${host}:7218`,
  // Ambulance-tracking link sent to a facility coordinator on dispatch (WhatsApp).
  DISPATCH_TRACKING_BASE: 'https://grobogan.beomhots.com/app/dispatch',
};

if (DEBUG) {
  // for development
  URLS = {
    FRONT: `${host}:5173`,
    BACK_DSH: `${host}:7270/api/dsh`,
    BACK_ENV: `${host}:7211/api/env`,
    WS: `ws://${location.hostname}:7212`,
    DSH_WS: `ws://${location.hostname}:7270`,
    MQTT_INTERNAL: 'wss://grobogan.beomhots.com/mqtt',
    MQTT_DSH: 'wss://grobogan.beomhots.com/mqtt-dsh',
    STREAM_PROXY: `${host}:7218`,
    DISPATCH_TRACKING_BASE: 'https://grobogan.beomhots.com/app/dispatch',
  };
}

export { URLS };

export const APIS = {
  checkStatus: '/authentication/check-status',
  accessMenu: '/program-navbar',
  userLanguage: '/common/authenticated-user/language-preference',
  language: '/common/authenticated-user/languages',
  updateLanguagePreference: '/users/language-preference',
  programLanguage: '/common/authenticated-user/programs',
  login: '/authentication/login',
  logout: '/authentication/logout',
  //user
  usersList: (filterParams: string) => `/users?${filterParams}`,
  detailUser: (userID: string) => `/users/${userID}`,
  deleteUser: (userID: string) => `/users/${userID}`,
  createUser: '/users',
  updateUser: '/users/update',
  //code
  codeList: (filterParams: string) => `/codes?${filterParams}`,
  detailCode: (codeID: string) => `/codes/${codeID}`,
  createUpperCode: '/codes',
  createLowerCode: '/codes/lower',
  updateUpperCode: (codeID: string) => `/codes/${codeID}`,
  updateLowerCode: (codeID: string) => `/codes/lower/${codeID}`,
  deleteCode: (codeID: string) => `/codes/${codeID}`,
  //language management
  languageList: (filterParams: string) => `/languages?${filterParams}`,
  detailLanguage: (tag: string) => `/languages/${tag}`,
  createLanguage: '/languages',
  updateLanguage: (tag: string) => `/languages/${tag}`,
  deleteLanguage: (tag: string) => `/languages/${tag}`,
  initialAuthority: (filterParams: string) => `/authority/groups?${filterParams}`,
  programAuthenticated: (filterParams: string) =>
    `/programs/authenticated-user-language?${filterParams}`,
  upperProgram: '/programs/upper-programs',
  groupProgram: (groupCode: number) => `/authority/groups/${groupCode}/programs`,
  //program
  programList: (filterParams: string) => `/programs?${filterParams}`,
  detailProgram: (programID: string) => `/programs/${programID}`,
  createUpperProgram: '/programs',
  createLowerProgram: '/programs/lower',
  updateUpperProgram: (programID: string) => `/programs/${programID}`,
  updateLowerProgram: (programID: string) => `/programs/lower/${programID}`,
  deleteProgram: (programID: string) => `/programs/${programID}`,
  //
  initialAuthorityUser: (filterParams: string) => `/authority/groups/users?${filterParams}`,
  authorityUserAssignInfo: (groupCode: number) => `/authority/groups/${groupCode}/users`,
  authorityUserInfo: (groupCode: number) => `/authority/groups/${groupCode}`,
  createAuthority: '/authority/groups',
  forgotPassword: '/forgot-password',
  updateProfileByUser: '/users/update-user',
  updateProfilePassword: '/users/update-password',
  //
  unmappedSiteRoad: (filterParams: string) => `/unmapped-site-road?${filterParams}`,
  //box
  boxList: (filterParams: string) => `/box?${filterParams}`,
  detailBox: (rtuID: string) => `/box/${rtuID}`,
  deleteBox: (rtuID: string) => `/box/${rtuID}`,
  createBox: '/box',
  updateBox: (rtuID: string) => `/box/${rtuID}`,
  //detector
  detectorList: (filterParams: string) => `/detector?${filterParams}`,
  detailDetector: (dtID: string) => `/detector/${dtID}`,
  deleteDetector: (dtID: string) => `/detector/${dtID}`,
  createDetector: '/detector',
  updateDetector: (dtID: string) => `/detector/${dtID}`,
  updateDetectorDt: (dtID: number) => `/detector/digital-twin/${dtID}`,
  //box-detector-facility
  boxDetectorFacilityList: (siteId: string) => `/box-detector-facility/${siteId}`,
  //cctv
  cctvList: (filterParams: string) => `/cctv?${filterParams}`,
  //cctv management (asset-management CRUD)
  cctvManagementList: (filterParams: string) => `/cctv/management?${filterParams}`,
  detailCctvManagement: (cctvId: string) => `/cctv/management/${cctvId}`,
  createCctvManagement: '/cctv/management',
  updateCctvManagement: (cctvId: string) => `/cctv/management/${cctvId}`,
  deleteCctvManagement: (cctvId: string) => `/cctv/management/${cctvId}`,
  //site
  siteList: (filterParams: string) => `/site?${filterParams}`,
  detailSite: (siteId: string) => `/site/${siteId}`,
  updateSite: (siteId: number) => `/site/${siteId}`,
  deleteSite: (siteId: number) => `/site/${siteId}`,
  createSite: '/site',
  //facility
  facilityList: (filterParams: string) => `/facility?${filterParams}`,
  detailFacility: (fcID: string) => `/facility/${fcID}`,
  deleteFacility: (fcID: string) => `/facility/${fcID}`,
  createFacility: '/facility',
  updateFacility: (fcID: string) => `/facility/${fcID}`,
  //ambulance management (asset-management CRUD)
  ambulanceManagementList: (filterParams: string) => `/ambulance?${filterParams}`,
  detailAmbulanceManagement: (ambulanceId: string) => `/ambulance/${ambulanceId}`,
  createAmbulanceManagement: '/ambulance',
  updateAmbulanceManagement: (ambulanceId: string) => `/ambulance/${ambulanceId}`,
  deleteAmbulanceManagement: (ambulanceId: string) => `/ambulance/${ambulanceId}`,
  //health care facility (id+name dropdown)
  healthCareFacilityDropdownList: (filterParams: string) =>
    `/health-care-facility/list?${filterParams}`,
  //health care facility management (asset-management CRUD)
  healthCareFacilityManagementList: (filterParams: string) =>
    `/health-care-facility?${filterParams}`,
  detailHealthCareFacilityManagement: (id: string) => `/health-care-facility/${id}`,
  createHealthCareFacilityManagement: '/health-care-facility',
  updateHealthCareFacilityManagement: (id: string) => `/health-care-facility/${id}`,
  deleteHealthCareFacilityManagement: (id: string) => `/health-care-facility/${id}`,
  //infra & facility management (shared backend for the Infrastructure and Facility asset-management pages)
  infraFacilityList: (filterParams: string) => `/infra-facility?${filterParams}`,
  detailInfraFacility: (id: string) => `/infra-facility/${id}`,
  createInfraFacility: '/infra-facility',
  updateInfraFacility: (id: string) => `/infra-facility/${id}`,
  deleteInfraFacility: (id: string) => `/infra-facility/${id}`,
  //road
  roadList: (filterParams: string) => `/road?${filterParams}`,
  createRoad: '/road',
  deleteRoad: (roadId: number) => `/road/${roadId}`,
  updateRoad: (roadId: number) => `/road/${roadId}`,
  detailRoadStreamURL: (roadId: number) => `/road/${roadId}/stream_url`,
  //statistic
  object: (filterParams: string) => `/object?${filterParams}`,
  objectTrafficAll: (filterParams: string) => `/object-traffic/all?${filterParams}`,
  objectTraffic: (filterParams: string) => `/object-traffic/aggregated?${filterParams}`,
  objectCnt: (filterParams: string) => `/object-cnt/vehicle?${filterParams}`,
  objectCntAll: (filterParams: string) => `/object-cnt/vehicle-all?${filterParams}`,
  objectCntLane: (filterParams: string) => `/object-cnt/lane?${filterParams}`,
  objectCntLaneAll: (filterParams: string) => `/object-cnt/lane-all?${filterParams}`,
  directionalTraffic: (filterParams: string) => `/overview/traffic?${filterParams}`,
  //Main dashboard
  mapInitialView: '/map/initial-view',
  mapDisplayPOI: '/map/poi',
  siteRoad: (filterParams: string) => `/site-road?${filterParams}`,
  //air event list
  airEventList: (filterParams: string) => `/air-event?${filterParams}`,
  //traffic event list
  trafficEventTime: (filterParams: string) => `/traffic-event-list/by-time?${filterParams}`,
  trafficEventRecent: (filterParams: string) => `/traffic-event-list/recent?${filterParams}`,
  //traffic event
  trafficEvent: (id: string) => `/traffic-event/${id}`,
  //traffic event count
  trafficEventCnt: (filterParams: string) => `/traffic-event-cnt?${filterParams}`,
  objectUnqCnt: (filterParams: string) => `/object-unq-cnt/vehicle/total?${filterParams}`,
  objectUnqCntRoad: (filterParams: string) => `/object-unq-cnt/road-vehicle?${filterParams}`,
  //total-traffic
  totalTraffic: (filterParams: string) => `/total-traffic/aggregated?${filterParams}`,
  //Crossroad
  siteRoadDetector: (id: number) => `/site-road-detector/${id}`,
  //object unq cnt
  objectCntCompass: (filterParams: string) => `/object-unq-cnt/compass/total?${filterParams}`,
  objectCntCompassTime: (filterParams: string) =>
    `/object-unq-cnt/compass/time-series?${filterParams}`,
  objectCntMovingDirectionTime: (filterParams: string) =>
    `/object-unq-cnt/moving-direction/time-series?${filterParams}`,
  objectCntVehicleDirectionTime: (filterParams: string) =>
    `/object-unq-cnt/vehicle-direction/time-series?${filterParams}`,
  objectCntDirectionTime: (filterParams: string) =>
    `/object-unq-cnt/direction/time-series?${filterParams}`,
  //By Road
  objectCntRoadTime: (filterParams: string) => `/object-unq-cnt/road/time-series?${filterParams}`,
  objectCntRoad: (filterParams: string) => `/object-unq-cnt/road/total?${filterParams}`,
  objectTrafficRoad: (filterParams: string) => `/object-traffic/road?${filterParams}`,
  //real time object position
  realTimeObject: (filterParams: string) => `/real-time-object?${filterParams}`,
  checkObject: (filterParams: string) => `/real-time-object/check?${filterParams}`,
  //Equipment Info
  boxStatus: (id: string) => `/box-status/${id}`,
  box: (id: string) => `/box/${id}`,
  boxEvent: (id: string, filterParams: string) => `/box-event/${id}?${filterParams}`,
  boxEventCnt: (id: string) => `/box-event-cnt/${id}`,
  boxTempHum: (id: string, filterParams: string) => `/box-temp-hum/${id}?${filterParams}`,
  boxCommand: (rtuID: number) => `/box/${rtuID}/power/command`,
  mosCommand: (siteID: string) => `/site/${siteID}/mos/command`,
  // Lane Info
  laneInfo: (filterParams: string) => `/lane-polygons?${filterParams}`,
  // scenario managemnt
  scenarioList: (filterParams: string) => `/scenario?${filterParams}`,
  detailScenario: (scenarioId: string) => `/scenario/${scenarioId}`,
  deleteScenario: (scenarioId: string) => `/scenario/${scenarioId}`,
  createScenario: () => `/scenario`,
  updateScenario: (scenarioId: string) => `/scenario/${scenarioId}`,
  // -event management
  // -device operation management
  deviceOprationList: (filterParams: string) => `/device-operation?${filterParams}`,
  detailDeviceOperation: (deviceOperationId: string) => `/device-operation/${deviceOperationId}`,
  deleteDeviceOperation: (deviceOperationId: string) => `/device-operation/${deviceOperationId}`,
  createDeviceOperation: () => '/device-operation',
  updateDeviceOperation: (deviceOperationId: string) => `/device-operation/${deviceOperationId}`,
  createDeviceOperationAndDom: () => `/device-operation/dom`,
  updateDeviceOperationAndDom: (deviceOperationId: string) =>
    `/device-operation/dom/${deviceOperationId}`,
  // event management
  detectionList: (filterParams: string) => `/detection?${filterParams}`,
  detailDetection: (detectionId: string) => `/detection/${detectionId}`,
  updateDetection: (detectionId: string) => `/detection/${detectionId}`,
  deleteDetection: (detectionId: string) => `/detection/${detectionId}`,
  createDetection: '/detection',
  //Manual Command
  manualSpeakerCommand: (facilityID: string) => `/device-operation/manual/speaker/${facilityID}`,
  manualVmsCommand: (facilityID: string) => `/device-operation/manual/vms/${facilityID}`,
  manualGoboCommand: (facilityID: string) => `/device-operation/manual/gobo/${facilityID}`,
  //Preference
  preference: '/common/system-preference',
  preferenceFile: '/common/system-preference/file',
  //Traffic Series chart
  trafficSeries: (filterParams: string) => `/object-traffic/time-series?${filterParams}`,
  trafficEventCount: (filterParams: string) => `/traffic-event/road/time-series?${filterParams}`,
  //Gobo Image
  goboImageList: '/gobo/image',
  //Env Log
  envCollectionLogList: (filterParams: string) => `/air-log?${filterParams}`,
  envCollectionLogDetail: (requestId: string) => `/air-log/${requestId}`,

  // Air Quality Sensor
  airSensorList: (filterParams: string) => `/air-sensor?${filterParams}`,
  detailAirSensor: (airSensorID: string) => `/air-sensor/${airSensorID}`,
  deleteAirSensor: (airSensorID: string) => `/air-sensor/${airSensorID}`,
  updateAirSensor: (airSensorID: string) => `/air-sensor/${airSensorID}`,
  createAirSensor: () => `/air-sensor`,
  // Air Stats
  airQualityStatistic: (params: string) => `/air-stats?${params}`,
  airQualityMeasurementGraph: (params: string) => `/air-stats/measurement-graph?${params}`,

  // Air Quality Sensor - Additional endpoints - DSH_111 ~ DSH_115
  airSensorInfoDetail: (air_sensor_id: number) => `/air-sensor/${air_sensor_id}/detail`,
  airSensorStatus: (air_sensor_id: number) => `/air-sensor/${air_sensor_id}/status`,
  airSensorEventCount: (air_sensor_id: number) => `/air-sensor/${air_sensor_id}/event/count`,
  airSensorEventCountByType: (air_sensor_id: number) =>
    `/air-sensor/${air_sensor_id}/event/count/by-type`,
  airSensorEventList: (air_sensor_id: number) => `/air-sensor/${air_sensor_id}/event`,
  airSensorTimeSeries: (air_sensor_id: number, metric: string) =>
    `/air-sensor/${air_sensor_id}/${metric}`,

  //Overview
  overviewAsset: (filterParams: string) => `/overview/asset?${filterParams}`,
  overviewSite: (filterParams: string) => `/overview/site?${filterParams}`,
  //Traffic Volume - PSC_PC0203001_BE_001
  trafficVolumeByVehicle: (filterParams: string) => `/traffic-volume/by-vehicle?${filterParams}`,
  //Traffic Event Summary - PSC_PC0203001_BE_006
  trafficEventSummary: (filterParams: string) => `/traffic/event/summary?${filterParams}`,
  //Traffic Event List - PSC_PC0203001_BE_007
  trafficEventListToday: (filterParams: string) => `/traffic/event?${filterParams}`,
  //Vehicle In/Out Count - PSC_PC0203001_BE_004
  vehicleInOutCount: (filterParams: string) => `/traffic/vehicle-count?${filterParams}`,
  //Traffic Congestion Summary - PSC_PC0203001_BE_003
  trafficCongestion: (filterParams: string) => `/traffic-volume/congestion?${filterParams}`,
  //Traffic Congestion by Location - per-CCTV heatmap feed
  trafficCongestionByLocation: (filterParams: string) =>
    `/traffic-volume/congestion/by-location?${filterParams}`,
  //Traffic Volume & Avg-Speed Hourly Trend (24h) - PSC_PC0203001_BE_005
  trafficVolumeSpeedTrend: (filterParams: string) => `/traffic/trend?${filterParams}`,
  //Hourly Traffic Volume by Vehicle (peak-hours trend) - PSC_PC0203001
  trafficVolumeHourlyByVehicle: (filterParams: string) =>
    `/traffic-volume/by-vehicle/hourly?${filterParams}`,
  //Traffic Volume by Vehicle Excel export - PSC_PC0203001_BE_008
  trafficVolumeExport: (filterParams: string) => `/traffic-volume/export?${filterParams}`,
  //Traffic Event Excel export - PSC_PC0203001_BE_009
  trafficEventExport: (filterParams: string) => `/traffic/event/export?${filterParams}`,
  //Traffic Chart by CCTV Excel export - PSC_PC0204002_BE_001
  trafficCctvExport: (filterParams: string) => `/traffic/cctv/export?${filterParams}`,
};
